import queryString from 'query-string';
import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';
import { AddEditApi, List } from '../interfaces/transaction.interface';

const list = (payload: List) => {
  const { status, propertyId, transactionType, startDate, assignedTo, reviewedBy, endDate, debitCredit, invoiceId, searchText, vendorId, chargeable, expenseCategory, adjustAgainstClaim, claimSettled, ...others } = payload;
  const paging = buildPagingResponse(others);
  const url = `${API_ENDPOINTS.listTransactions}?${queryString.stringify(paging)}`;
  return http.post(url, {
    search: searchText,
    property_id: propertyId,
    start_date: startDate,
    end_date: endDate,
    assigned_to: assignedTo,
    reconciled_by: reviewedBy,
    transaction_type_id: transactionType,
    transaction_status: status && status.length ? status : undefined,
    debit_credit: debitCredit,
    invoice_id: invoiceId,
    vendor_id: vendorId,
    chargeable: chargeable || undefined,
    expense_category: expenseCategory || undefined,
    adjust_against_claim: adjustAgainstClaim || undefined,
    claim_settled: claimSettled || undefined,
  });
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.transactions, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.transactions}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.transactions}/${id}`);
};

const transactionTypeslookup = (payload: { searchText: string; orderBy: string; order: string; }) => {
  const url = `${API_ENDPOINTS.lookupTransactionTypes}?${queryString.stringify({ search: payload.searchText, from: 'transaction', order_by: payload.orderBy, order: payload.order })}`;
  return http.get(url);
};

const deleteTransaction = (id: string) => {
  return http.delete(`${API_ENDPOINTS.transactions}/${id}`);
};

const TransactionService = {
  list,
  get,
  add,
  edit,
  transactionTypeslookup,
  deleteTransaction
};

export default TransactionService;


